import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../util/network-call/network-call";

export const AdminModuleEditLoader = async (args: LoaderFunctionArgs) => {

    const response = await networkCall(`/modules/${ args.params.id }`);

    return { response, id: args.params.id };

};